import { WToolButton, type WToolButtonProps } from "@/components/button/WToolButton.tsx";
import { useLingui } from "@lingui/react/macro";

export function UnAssignButton(props: Omit<WToolButtonProps, "icon" | "label">) {
    const { t } = useLingui();
    return (
        <WToolButton icon="jp-wrong-icon" color={props.inTable ? "error" : "primary"} label={t`Unassign`} {...props} />
    );
}
